module.exports = __webpack_public_path__ + "img/组 58.119a4792.png";